import org_model from "@iscr/models/org_model";
export const getSpecPrices = () => org_model.org_conf_itm(app.user.org, "prods_sale__med_cosm__spec_prices") || {};
export const getPriceCoeff = () => org_model.org_conf_itm(app.user.org, "prods_sale__med_cosm__price_coeff") || 1;
